import { render, staticRenderFns } from "./EditTOG.vue?vue&type=template&id=63fafd6e&scoped=true"
import script from "./EditTOG.vue?vue&type=script&lang=js"
export * from "./EditTOG.vue?vue&type=script&lang=js"
import style0 from "./EditTOG.vue?vue&type=style&index=0&id=63fafd6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fafd6e",
  null
  
)

export default component.exports